import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Dashboard: React.FC = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const handleViewQRCode = () => {
    navigate('/qrcode');
  };

  if (!user) {
    return null;
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <nav className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16">
            <div className="flex items-center">
              <h1 className="text-xl font-semibold text-gray-900">
                Dashboard Peserta
              </h1>
            </div>
            <div className="flex items-center">
              <button
                onClick={handleLogout}
                className="ml-4 px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700"
              >
                Keluar
              </button>
            </div>
          </div>
        </div>
      </nav>

      <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        <div className="px-4 py-6 sm:px-0">
          <div className="bg-white overflow-hidden shadow rounded-lg">
            <div className="px-4 py-5 sm:p-6">
              <h3 className="text-lg leading-6 font-medium text-gray-900 mb-4">
                Informasi Peserta
              </h3>
              
              <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                <div>
                  <dt className="text-sm font-medium text-gray-500">Nama</dt>
                  <dd className="mt-1 text-sm text-gray-900">{user.nama_pendaftar}</dd>
                </div>
                
                <div>
                  <dt className="text-sm font-medium text-gray-500">ID Pendaftaran</dt>
                  <dd className="mt-1 text-sm text-gray-900">{user.id_pendaftaran}</dd>
                </div>
                
                <div>
                  <dt className="text-sm font-medium text-gray-500">Nomor HP</dt>
                  <dd className="mt-1 text-sm text-gray-900">{user.hp}</dd>
                </div>
                
                <div>
                  <dt className="text-sm font-medium text-gray-500">Event</dt>
                  <dd className="mt-1 text-sm text-gray-900">{user.nama_event}</dd>
                </div>
                
                <div>
                  <dt className="text-sm font-medium text-gray-500">Paket</dt>
                  <dd className="mt-1 text-sm text-gray-900">{user.paket}</dd>
                </div>
              </div>

              <div className="mt-8">
                <button
                  onClick={handleViewQRCode}
                  className="w-full sm:w-auto inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                >
                  Lihat QR Code
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard; 